import gql from "graphql-tag.macro";
import axios from "axios";

const mutationReset = gql`
    mutation {
        reset {
            reset
            status
            message
        }
    }
`;

export const backupData = async () => {
    if (
        [
            "demo.masterdocs.com.au",
            "demo1.masterdocs.com.au",
            "demo2.masterdocs.com.au",
            "demo3.masterdocs.com.au",
            "test1.masterdocs.com.au",
            "test2.masterdocs.com.au",
            "test3.masterdocs.com.au",
            "dev1.dart.masterdocs.com.au",
            "dev2.dart.masterdocs.com.au",
            "dev3.dart.masterdocs.com.au",
            "testcorporate.dart.masterdocs.com.au",
            "testnoncorporate.dart.masterdocs.com.au",
            "testcompany.dart.masterdocs.com.au",
            "uat1.dart.masterdocs.com.au",
            "uat2.dart.masterdocs.com.au",
            "uat3.dart.masterdocs.com.au",
            "127.0.0.1:5003",
            "localhost:5003",
            "preview.dart.masterdocs.com.au",
        ].includes(window.location.host)
    ) {
        const response = await axios.get(
            `${window.location.origin}/api/backup`
        );
        window.location.reload();
        console.log(response);
        return response;
    } else {
        throw new Error("Reset data cannot run in production");
    }
};

export const restoreData = async () => {
    if (
        [
            "demo.masterdocs.com.au",
            "demo1.masterdocs.com.au",
            "demo2.masterdocs.com.au",
            "demo3.masterdocs.com.au",
            "test1.masterdocs.com.au",
            "test2.masterdocs.com.au",
            "test3.masterdocs.com.au",
            "dev1.dart.masterdocs.com.au",
            "dev2.dart.masterdocs.com.au",
            "dev3.dart.masterdocs.com.au",
            "testcorporate.dart.masterdocs.com.au",
            "testnoncorporate.dart.masterdocs.com.au",
            "testcompany.dart.masterdocs.com.au",
            "uat1.dart.masterdocs.com.au",
            "uat2.dart.masterdocs.com.au",
            "uat3.dart.masterdocs.com.au",
            "127.0.0.1:5003",
            "localhost:5003",
            "preview.dart.masterdocs.com.au",
        ].includes(window.location.host)
    ) {
        const response = await axios.get(
            `${window.location.origin}/api/restore`
        );
        if (!response?.data?.success) {
            alert(response.data.message)
            throw new Error(response.data.message);
        }
        window.location.reload();
        return response;
    } else {
        throw new Error("Reset data cannot run in production");
    }
};

export const resetData = async ({ client }) => {
    if (
        [
            "demo.masterdocs.com.au",
            "demo1.masterdocs.com.au",
            "demo2.masterdocs.com.au",
            "demo3.masterdocs.com.au",
            "test1.masterdocs.com.au",
            "test2.masterdocs.com.au",
            "test3.masterdocs.com.au",
            "dev1.dart.masterdocs.com.au",
            "dev2.dart.masterdocs.com.au",
            "dev3.dart.masterdocs.com.au",
            "testcorporate.dart.masterdocs.com.au",
            "testnoncorporate.dart.masterdocs.com.au",
            "testcompany.dart.masterdocs.com.au",
            "uat1.dart.masterdocs.com.au",
            "uat2.dart.masterdocs.com.au",
            "uat3.dart.masterdocs.com.au",
            "127.0.0.1:5003",
            "localhost:5003",
            "preview.dart.masterdocs.com.au",
        ].includes(window.location.host)
    ) {
        const { data } = await client.mutate({
            mutation: mutationReset,
            fetchPolicy: "no-cache",
        });
        console.log(data);
        window.location.reload();
        return data;
    } else {
        throw new Error("Reset data cannot run in production");
    }
};
